export const de = {
  home: {
    download: {
      ios: 'Im App Store laden',
      iosSubtitle: 'iPhone & iPad',
      cta: 'Laden',
    },
    location: {
      useMyLocation: 'Meinen Standort verwenden',
      modalBadge: 'Standort',
      modalTitle: 'Stadt auswählen',
      tabs: {
        cities: 'Städte',
        coords: 'Koordinaten',
      },
      searchPlaceholder: 'Stadt suchen…',
      refresh: 'Aktualisieren',
      loading: 'Städte werden geladen…',
      empty: 'Keine Städte gefunden.',
      loadError: 'Die Städte konnten nicht geladen werden. Bitte versuch es noch einmal.',
      scrollMore: 'Scrolle, um mehr zu laden…',
      coords: {
        latitude: 'Breitengrad',
        longitude: 'Längengrad',
        timezone: 'Zeitzone (optional)',
        latPlaceholder: 'z. B. 43.8563',
        lngPlaceholder: 'z. B. 18.4131',
        tzPlaceholder: 'z. B. Europe/Sarajevo',
        tzHint: 'Wenn du nichts einträgst, verwenden wir die Zeitzone deines Geräts.',
        apply: 'Koordinaten verwenden',
        clear: 'Löschen',
        invalidLat: 'Der Breitengrad muss zwischen -90 und 90 liegen.',
        invalidLng: 'Der Längengrad muss zwischen -180 und 180 liegen.',
      },
    },
    header: {
      brand: 'Deenly',
      login: 'Anmelden',
      downloadApp: 'App laden',
      prayers: {
        fajr: 'Fajr',
        dhuhr: 'Dhuhr',
        asr: 'Asr',
        maghrib: 'Maghrib',
        isha: 'Isha',
      },
    },
    hero: {
      badge: 'Großes Update 2.0',
      titleLine1: 'Dein ganzer',
      titleGradient: 'Deen, neu gedacht.',
      subtitle:
        'Von einem umfassenden Feed mit Gelehrten und Tajwid mit KI über die Kaaba in AR und Live-Übersetzungen der Khutba bis zum PIN-geschützten Kindermodus. Alles, was du brauchst.',
    },
    nextPrayer: {
      label: 'Nächstes Gebet',
      statusOnTime: 'Pünktlich',
      startsIn: 'Beginnt in',
      meta: {
        locationLabel: 'Sarajevo',
        methodLabel: 'MWL-Berechnung',
        alertsOn: 'Erinnerungen an',
        alertsOff: 'Erinnerungen aus',
      },
    },
    podcast: {
      badge: 'PODCAST MIT GELEHRTEN',
      titlePrefix: 'Bucherklärung:',
      titleMain: 'Riyad as-Salihin',
      author: 'Sheikh Mufti Menk',
    },
    features: {
      title: 'Alles, was du brauchst.',
      subtitle: 'Liebevoll gestaltete Werkzeuge zum Lesen, Hören, Mitverfolgen und für deinen täglichen Gottesdienst.',
      core: {
        dynamicFeed: {
          title: 'Dynamischer Feed',
          body: 'Bücher, Seiten, Hadithe, Koranverse des Tages und Podcasts, die klassische Texte erklären.',
          bookAddedLabel: 'Buch hinzugefügt',
          bookAddedValue: 'Der versiegelte Nektar',
          podcastLabel: 'Podcast',
          podcastValue: 'Tafsir Ibn Kathir',
        },
        mosqueNavigator: {
          badge: 'Live-Navigation',
          title: 'Smarter Moschee-Navigator',
          body:
            'Erstklassige Navigation führt dich Schritt für Schritt zur nächsten Moschee. Wähle deine Lieblingsmoschee, behalte die Ankunftszeit im Blick und verpasse nie wieder die Jama’ah.',
          cardTitle: 'Zentralmoschee',
          cardMeta: 'Ankunft: 5 Min. • zu Fuß',
        },
        dreamInterpreter: {
          title: 'KI-Traumdeuter',
          body: 'Verstehe deine Träume aus islamischer Sicht, mit unserer KI, die auf klassischen Texten trainiert wurde.',
          cta: 'Jetzt fragen',
        },
        libraryStats: {
          title: 'Smarte Bibliothek & Statistiken',
          body:
            'Lies den Koran ganz ohne Unterbrechung. Halte einen Vers gedrückt, um ihn als Lesezeichen zu speichern oder das Tajwid-Fenster zu öffnen: Lies laut vor und erhalte sofort Rückmeldung der KI zu deiner Aussprache. Mit dem interaktiven Regler berechnest du genau, wann du den Koran abschließen wirst.',
          chips: {
            pages: 'Seiten',
            bookmarks: 'Lesezeichen',
            tajweedCheck: 'Tajwid-Check',
          },
          paceLabel: 'Tagesziel',
          paceValue: '20 Verse',
          finishLabel: 'Koran abgeschlossen in',
          finishValue: '105 Tagen',
          longPressLabel: 'Gedrückt halten',
          longPressValue: 'Vers 255',
        },
      },
      premium: {
        badge: 'Die ganze Sammlung',
        title: 'Islamische Premium-Werkzeuge',
        subtitle: 'Eine vollständige Sammlung leistungsstarker Werkzeuge für alle Muslime.',
        arQibla: {
          title: 'AR-Qibla & Kaaba',
          body:
            'Finde mit moderner AR-Technik die genaue Richtung der Qibla. Platziere eine virtuelle Kaaba direkt vor dir und tauche ganz in das Erlebnis ein.',
          cta: 'AR-Ansicht öffnen',
        },
        postureGuide: {
          title: 'Gebetshaltungen',
          body:
            'Stell dein Handy so ab, dass es zu dir zeigt. Unsere KI erkennt deine Bewegungen und begleitet dich sicher durch die Haltungen des Gebets.',
        },
        liveKhutbah: {
          title: 'Live-Khutba',
          body:
            'Beim Jumu’ah im Ausland? Die KI übersetzt dir die Predigt des Imams in Echtzeit direkt auf deinen Bildschirm.',
        },
        tajweed: {
          title: 'Koranrezitation mit KI',
          body:
            'Übe deine Rezitation. Die KI hört auf dein Tajwid, zeigt dir sofort, wo du dich verbessern kannst, und gibt dir genaue Rückmeldung.',
        },
        essentials: {
          title: 'Wichtige Helfer für jeden Tag',
          body:
            'Alles, was du sonst noch brauchst: ein Halal-Barcode-Scanner für Zutaten, ein klassisches Tipp-Tasbih und ein genauer Zakat-Rechner.',
          halalScanner: 'Halal-Scanner',
          tapTasbih: 'Tipp-Tasbih',
          zakat: 'Zakat-Rechner',
        },
      },
    },
    kids: {
      badge: 'Deenly Kids',
      title: 'Ein sicherer, schöner Ort für deine Kleinen.',
      subtitle:
        'Alles, was dein Kind braucht, um zu lernen und friedlich zu schlafen, sicher geschützt durch einen Eltern-PIN.',
      items: {
        pictureBooks: {
          title: 'Bilderbücher',
          body: 'Interaktive, wunderschön illustrierte Geschichten, die grundlegende islamische Werte und gutes Benehmen vermitteln.',
        },
        lullabies: {
          title: 'Halal-Schlaflieder (ohne Musik)',
          body: 'Beruhigende Stimmen, eigens für Babys aufgenommen, damit sie friedlich einschlafen. Ganz ohne Musik.',
        },
        whiteNoise: {
          title: 'Weißes Rauschen & Schlafklänge',
          body: 'Eine Auswahl sanfter Naturklänge und weißes Rauschen, die beim Zur-Ruhe-Kommen helfen.',
        },
        games: {
          title: 'Interaktive Spiele',
          body: 'Spannende, sichere und durchweg lehrreiche Minispiele, genau passend für jüngere Kinder.',
        },
        pin: {
          title: 'Sicherer PIN-Modus',
          badge: 'Gesichert',
          body: 'Kinder bleiben im geschützten Kinderbereich. Ohne deinen Eltern-PIN können sie ihn nicht verlassen.',
        },
      },
    },
    cta: {
      title: 'Beginne deinen Weg noch heute.',
      subtitle: 'Schließe dich Millionen Muslimen weltweit an, die sich mit Deenly bessere tägliche Gewohnheiten aufbauen.',
      ios: 'Für iOS laden',
      android: 'Für Android laden',
    },
    footer: {
      copyright: '© 2023 Deenly. Alle Rechte vorbehalten.',
      links: {
        privacy: 'Datenschutzerklärung',
        terms: 'Nutzungsbedingungen',
        contact: 'Kontakt',
      },
    },
  },
  legal: {
    privacy: {
      metaTitle: 'Datenschutz & Nutzungsbedingungen • Deenly',
      header: {
        badge: 'Rechtliches Dokument',
        back: 'Zurück',
      },
      hero: {
        titlePrefix: 'Deine ',
        titleGradient: 'Privatsphäre.',
        subtitle:
          'Deine Daten sind deine Sache, nicht unsere. Unser Grundsatz: so wenig wie möglich erheben und dir trotzdem ein erstklassiges Erlebnis bieten.',
        lastUpdatedLabel: 'Zuletzt aktualisiert',
        badgeIcon: 'solar:shield-check-linear',
        calendarIcon: 'solar:calendar-linear',
      },
      languageLabel: 'Sprache',
      lang: {
        en: 'English',
        bs: 'Bosanski',
        de: 'Deutsch',
        nl: 'Nederlands',
        fr: 'Français',
      },
      search: {
        title: 'Suche',
        placeholder: 'Suchen (z. B. „Daten“, „Konto“, „Dritte“)',
        found: 'Gefundene Abschnitte',
        clear: 'Löschen',
        tocTitle: 'Inhalt',
        tocHint: 'Direkt zu einem Abschnitt springen.',
        emptyTitle: 'Keine Ergebnisse',
        emptyBody:
          'Kein Abschnitt passt zu deiner Suche. Versuch es mit einem anderen Begriff.',
        backToTop: 'Nach oben',
        backHome: 'Zur Startseite',
      },
      tldr: {
        title: 'Das Wichtigste in Kürze',
        icon: 'solar:bolt-linear',
        cards: [
          {
            icon: 'solar:eye-closed-linear',
            title: 'Niemals Werbung',
            body: 'Wir verkaufen deine Daten nicht an Werbetreibende. Deenly finanziert sich ausschließlich über Premium-Abos.',
          },
          {
            icon: 'solar:map-point-linear',
            title: 'Standort bleibt lokal',
            body: 'Die Gebetszeiten werden direkt auf deinem Gerät berechnet. Wir verfolgen niemals deine Bewegungen.',
          },
          {
            icon: 'solar:lock-keyhole-minimalistic-linear',
            title: 'Verschlüsselte Synchronisierung',
            body: 'Deine Lesezeichen und persönlichen Statistiken werden bei der Übertragung und bei der Speicherung verschlüsselt.',
          },
          {
            icon: 'solar:smile-circle-linear',
            title: 'Kinder sind geschützt',
            body: 'Der Kindermodus entspricht dem COPPA und erhebt keinerlei Telemetriedaten.',
          },
        ],
      },
      toc: [
        { id: 'tldr', label: 'Das Wichtigste in Kürze' },
        { id: 'collection', label: 'Erhebung' },
        { id: 'usage', label: 'Datennutzung' },
        { id: 'kids', label: 'Datenschutz für Kinder' },
        { id: 'sharing', label: 'Weitergabe' },
        { id: 'security', label: 'Sicherheit' },
        { id: 'contact', label: 'Kontakt' },
      ],
      collection: {
        title: 'Welche Daten wir erheben',
        intro:
          'Wir erheben so wenige Daten wie möglich. Hier steht genau, was passiert, wenn du Deenly nutzt.',
        items: [
          {
            icon: 'solar:key-minimalistic-2-linear',
            title: 'Gerätekennung (UUID)',
            bodyParts: [
              { text: 'Beim ersten Start erzeugt die App eine zufällige ', highlight: false },
              { text: 'UUID', highlight: true },
              { text: ' und speichert sie sicher in der Sitzung deines Geräts (Keychain / Keystore). Diese Kennung dient ausschließlich dazu, dein Gerät bei unseren Servern zu registrieren. Sie verlässt das Gerät nur zur Authentifizierung gegenüber unserer API.', highlight: false },
            ],
          },
          {
            icon: 'solar:lock-keyhole-minimalistic-linear',
            title: 'Sitzungstoken (JWT)',
            bodyParts: [
              { text: 'Nach der Registrierung stellt unser Server ein ', highlight: false },
              { text: 'JWT', highlight: true },
              { text: ' aus, das ausschließlich in der Sitzung deines Geräts gespeichert wird. Alle weiteren API-Anfragen verwenden dieses Token. Eine herkömmliche Anmeldung mit Benutzername und Passwort gibt es nicht: Deine Identität ist die Sitzung deines Geräts.', highlight: false },
            ],
          },
          {
            icon: 'solar:routing-2-linear',
            title: 'Standortdaten (auf dem Gerät)',
            bodyParts: [
              { text: 'Sie werden ausschließlich benötigt, um genaue Gebetszeiten und die Richtung der Qibla zu berechnen. Die Berechnung erfolgt ', highlight: false },
              { text: 'lokal auf deinem Gerät', highlight: true },
              { text: '. Wir speichern oder übertragen deinen Standortverlauf niemals.', highlight: false },
            ],
          },
          {
            icon: 'solar:mic-2-linear',
            title: 'Zugriff auf das Mikrofon',
            body:
              'Wird für die KI-Prüfung deiner Rezitation und die Live-Übersetzung der Khutba verwendet. Die Spracherkennung läuft auf deinem Gerät: Das Audio selbst wird von uns niemals hochgeladen, aufgezeichnet oder gespeichert. Was das Gerät verlassen kann, ist Text, wie unten beschrieben.',
          },
          {
            icon: 'solar:document-text-linear',
            title: 'KI-Textverarbeitung (Transkripte & Träume)',
            bodyParts: [
              { text: 'Manche KI-Funktionen brauchen mehr Rechenleistung, als ein Handy hat. Wenn du die Live-Übersetzung der Khutba nutzt, wird der erkannte ', highlight: false },
              { text: 'Text jedes Satzes', highlight: true },
              { text: ' (niemals das Audio) über eine verschlüsselte Verbindung an unsere Server gesendet und an einen vertrauenswürdigen KI-Verarbeitungspartner weitergegeben, der die Übersetzung und die Zusammenfassung am Ende der Khutba erstellt. Traumbeschreibungen, die du beim Traumdeuter eingibst, werden genauso verarbeitet. Diese Anfragen enthalten nur die Sitzung deines Geräts, nicht deinen Namen oder deine Kontaktdaten. Dein Khutba-Verlauf wird nur auf deinem Gerät gespeichert; Übersetzungen werden bis zu 30 Tage auf unseren Servern zwischengespeichert, damit eine ganze Gemeinde, die derselben Khutba folgt, sie sofort erhält; geteilte Transkripte aus „Räumen“ werden innerhalb weniger Stunden von unseren Servern gelöscht.', highlight: false },
            ],
          },
        ],
      },
      usage: {
        title: 'Wie wir Daten verwenden',
        intro:
          'Alle Daten, die wir erheben, verwenden wir ausschließlich, um dein Erlebnis zu verbessern. Wir erstellen keine Verhaltensprofile.',
        cards: [
          {
            icon: 'solar:cloud-sync-linear',
            title: 'Cloud-Synchronisierung',
            body:
              'Synchronisiere deine Koran-Lesezeichen, täglichen Statistiken und Einstellungen mühelos auf all deinen Geräten.',
          },
          {
            icon: 'solar:magic-stick-3-linear',
            title: 'Verarbeitung für KI-Funktionen',
            body:
              'Die satzweise Übersetzung der Khutba, ihre Zusammenfassungen und die Traumdeutungen entstehen aus Text, der an unsere Server und einen vertrauenswürdigen KI-Verarbeitungspartner gesendet wird. Die Anfragen sind nur mit der Sitzung deines Geräts verknüpft und werden niemals genutzt, um ein Profil von dir zu erstellen.',
          },
        ],
      },
      kids: {
        title: 'Datenschutz im Kindermodus',
        intro:
          'Die Privatsphäre von Minderjährigen nehmen wir außerordentlich ernst. Der Kinderbereich ist eine besonders sichere Umgebung, die vor allem offline funktioniert.',
        badge: {
          icon: 'solar:star-fall-minimalistic-2-linear',
          label: 'Besondere Regelung',
        },
        items: [
          {
            icon: 'solar:shield-check-linear',
            text: 'Keinerlei Tracking- oder Analyseskripte im Kindermodus.',
          },
          {
            icon: 'solar:document-text-linear',
            text: 'Vollständig konform mit dem COPPA und den DSGVO-Regeln für Kinder.',
          },
          {
            icon: 'solar:lock-password-linear',
            text: 'Keine externen Links oder Käufe ohne Eltern-PIN.',
          },
        ],
      },
      sharing: {
        title: 'Weitergabe von Daten',
        body:
          'Wir verkaufen, vermieten oder tauschen deine personenbezogenen Daten nicht an Dritte. Wir geben Informationen nur an besonders vertrauenswürdige Infrastrukturpartner weiter, und zwar ausschließlich zum Betrieb der Anwendung. Dazu gehört ein KI-Verarbeitungspartner, der nur den Text erhält, der für eine Funktion nötig ist (einen Satz der Khutba zum Übersetzen, eine Traumbeschreibung zum Deuten), niemals deine Identität. Diese Partner sind an strenge Vertraulichkeitsvereinbarungen gebunden und dürfen deine Daten nicht für eigene Zwecke verwenden, auch nicht für Werbung oder zum Training mit deinen Inhalten.',
      },
      security: {
        title: 'Sicherheitsmaßnahmen',
        body:
          'Dein Vertrauen ist unser größtes Gut. Wir setzen modernste Sicherheitsmaßnahmen ein, um deine Daten zu schützen. Die gesamte Kommunikation ist durch TLS-Verschlüsselung gesichert. Deine UUID und dein JWT werden nur in der sicheren Sitzung deines Geräts gespeichert (Keychain unter iOS, Keystore unter Android) und sind außerhalb deines Geräts niemals zugänglich.',
      },
      contactCta: {
        title: 'Fragen zum Datenschutz?',
        subtitle: 'Unser Datenschutz-Team hilft dir gerne weiter.',
        button: 'Datenschutz-Team kontaktieren',
        icon: 'solar:letter-linear',
      },
      footerNote: 'Alle Rechte vorbehalten. Gestaltet mit aufrichtiger Absicht.',
      footer: {
        links: {
          terms: 'Bedingungen',
          privacy: 'Datenschutz',
          cookies: 'Cookies',
        },
      },
    },
  },
};
